import { Input, Form as UnstyledForm, WorkspaceLogo } from '@sketch/components'
import styled from 'styled-components'

export const HeaderContainer = styled.div`
  padding: 20px 0;
`

export const HeaderContainerUpdateFlow = styled.div`
  padding: 24px 0 0;
`

export const ContentContainer = styled.div`
  padding: 24px 0;
`

export const Form = styled(UnstyledForm)`
  display: grid;
  gap: 16px;
`

export const InlineFormRow = styled.div`
  display: flex;
  gap: 20px;

  ${UnstyledForm.Field} {
    width: 100%;
  }
`

export const Separator = styled.hr`
  height: 1px;
  background-color: ${({ theme }) => theme.colors.border.B};
  margin: 0 -32px 0 -32px;
`

export const StyledInput = styled(Input)`
  :disabled {
    cursor: not-allowed;
  }
`

export const StyledWorkspaceLogo = styled(WorkspaceLogo)`
  cursor: not-allowed;
`
